/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-param-reassign */

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { format } from "date-fns";

const roundNumber = (num, scale) => {
  if (!`${num}`.includes("e")) {
    return +`${Math.round(`${num}e+${scale}`)}e-${scale}`;
  }
  const arr = `${num}`.split("e");
  let sig = "";
  if (+arr[1] + scale > 0) {
    sig = "+";
  }
  return +`${Math.round(`${+arr[0]}e${sig}${+arr[1] + scale}`)}e-${scale}`;
};

const PdfInvoices = (item) => {
  const tempListOfTickets = [];
  let discount = 0;
  let vatAmount = 0;
  for (let i = 0; i < item?.order?.items?.length; i++) {
    const itemObj = item?.order?.items[i];
    if (itemObj.lineItems.length === 0) {
      vatAmount = itemObj.vatAmount || 0;
      discount = itemObj.discount || 0;
      tempListOfTickets.push([
        itemObj.ref.title || "",
        ``,
        itemObj.totalPax,
        (
          (itemObj.itemTotalPrice.price.recommendedRetailPrice - (vatAmount || 0)) /
          itemObj.totalPax
        ).toFixed(2),
        (itemObj.itemTotalPrice.price.recommendedRetailPrice - (vatAmount || 0)).toFixed(2),
        discount?.toFixed(2) || 0,
        `${item?.order?.vatRate || 0}%`,
        vatAmount || 0,
        (itemObj.itemTotalPrice.price.recommendedRetailPrice - (discount || 0)).toFixed(2),
      ]);
    } else {
      for (let j = 0; j < itemObj.lineItems.length; j++) {
        const column = itemObj.lineItems[j];
        discount = (itemObj.discount || 0) / itemObj.lineItems.length || 0;
        vatAmount = (itemObj.vatAmount || 0) / itemObj.lineItems.length || 0;
        tempListOfTickets.push([
          itemObj.ref.title || "",
          `${column.ageBand}`,
          column.numberOfTravelers,
          (
            (column.subtotalPrice.price.recommendedRetailPrice - (vatAmount || 0)) /
            column.numberOfTravelers
          ).toFixed(2),
          (column.subtotalPrice.price.recommendedRetailPrice - (vatAmount || 0)).toFixed(2),
          discount?.toFixed(2) || 0,
          `${item?.order.vatRate}%`,
          vatAmount.toFixed(2) || 0,
          (column.subtotalPrice.price.recommendedRetailPrice - (discount || 0)).toFixed(2),
        ]);
      }
    }
  }
  // eslint-disable-next-line new-cap
  const doc = new jsPDF("p", "mm", "a4");
  // Add Image To PDF
  const imgWidth = 56.95;
  const imgHeight = 19.2;
  // Static base64 for example purposes
  const toPng =
    "data:image/png;base64,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";
  // const height = doc.internal.pageSize.getHeight();

  doc.addImage(toPng, "PNG", 150, 3, imgWidth, imgHeight);
  autoTable(doc, {
    head: [[""]],
    didParseCell(cell) {
      cell.cell.styles.fontStyle = "normal";
    },
    didDrawPage(data) {
      // Header
      doc.setFontSize(10).setFont("helvetica");

      doc.text("Advanced Digital Technolgy DWC-LLC", 3, 10);
      doc.text("Dubai Aviation City", 3, 15);
      doc.text("PO Box 390667 Dubai, U.A.E.", 3, 20);
      doc.text("TRN : 100441659800003", 3, 25).setFontSize(20).setFont("helvetica", "bold");
      doc.text("Tax Invoice", 80, 35).setFontSize(10).setFont("normal");
      doc.text("BILL TO", 3, 45);
      doc.text(
        `Date: ${item?.createdAt && format(new Date(item?.createdAt), "dd/MM/yyyy")}`,
        data.settings.margin.right + 145,
        45
      );

      doc.text(`Tax Invoice#: ${item?.invoiceNumber || ""}`, data.settings.margin.right + 145, 50);
      doc
        .text(
          `Place of Supply: ${item?.destinationName || ""}`,
          data.settings.margin.right + 145,
          55
        )
        .setFontSize(10)
        .setFont("normal");
      doc.text(`Customer Name: ${item?.customerName || ""}`, 3, 50);

      doc.text("Address:", 3, 55);
      doc.text("TRN:", 3, 60);
      doc.text(`Source: ${item.source || ""}`, data.settings.margin.right + 145, 60);
    },

    tableLineWidth: 0,
    tableLineColor: "black",
    tableWidth: "auto",
    startY: 10,
    startX: 100,
    theme: "plain",
    // format: "c0",
    putOnlyUsedFonts: true,
    pageBreak: "auto",

    cellPadding: 5,
    lineWidth: 0.1,
    columnWidth: 100, // 'auto', 'wrap' or a number
  });
  autoTable(doc, {
    styles: {
      fillColor: [171, 171, 171],
      lineColor: 240,
      lineWidth: 0.1,
    },
    bodyStyles: {
      fillColor: false,
    },
    margin: { top: 50, left: 5, right: 5, bottom: 10 },
    didParseCell(cell) {
      cell.cell.styles.fontSize = 9;
      cell.cell.tableWidth = 500;
      // console.log("cell", cell);
      if (cell.column.dataKey === 0) {
        // paint.Name header red
        cell.cell.styles.cellWidth = 25;
        //
        // cell.styles.textColor = [255, 0, 0];
      } else if (cell.column.dataKey === 1) {
        // cell.cell.styles.fillColor = "blue";
        cell.cell.styles.cellWidth = 30;
      } else if (cell.column.dataKey === 2) {
        // cell.cell.styles.fillColor = "blue";
        cell.cell.styles.cellWidth = 15;
      } else if (cell.column.dataKey === 3) {
        // cell.cell.styles.fillColor = "blue";
        cell.cell.styles.cellWidth = 30;
        // cell.cell.styles.fontSize = 8;
      } else {
        cell.cell.styles.cellWidth = 20;
      }
    },
    head: [
      [
        "Item Code",
        "Description",
        "Qty",
        "Rate",
        "Amount",
        "Discount",
        "VAT Rate",
        "VAT Amount",
        "Total Price",
      ],
    ],
    body: tempListOfTickets,
    foot: [
      [
        "",
        "",
        "",
        "SUBTOTAL:",
        `${item?.currency}: ${roundNumber(
          (item.totalAmount?.priceAfterLokaleeDiscount?.recommendedRetailPrice ||
            item.totalAmount?.price?.recommendedRetailPrice) - item.totalVatAmount,
          2
        ).toFixed(2)}`,
        // `item?.currency:`,
        // "",
        `${item?.currency}: ${item?.discount?.toFixed(2) || 0}`,
        "",
        `${item?.currency}: ${item?.totalVatAmount?.toFixed(2) || 0}`,
        `${
          item?.currency
        }: ${item.totalAmount.priceAfterLokaleeDiscount.recommendedRetailPrice.toFixed(2)}`,
      ],
    ],
    // margin: 20,
    tableLineWidth: 0.1,
    tableLineColor: "black",
    tableWidth: "auto",
    startY: doc.lastAutoTable.finalY + 60,
    startX: 20,
    theme: "plain",
    putOnlyUsedFonts: true,
    pageBreak: "auto",

    cellPadding: 5,
    lineWidth: 0.1,
    columnWidth: 100, // 'auto', 'wrap' or a number
  });
  autoTable(doc, {
    styles: {
      fillColor: [171, 171, 171],
      lineColor: 240,
      lineWidth: 0.1,
    },
    bodyStyles: {
      fillColor: false,
    },
    margin: { top: 50, left: 5, right: 5, bottom: 10 },
    didParseCell(cell) {
      cell.cell.styles.fontSize = 9;
      cell.cell.tableWidth = 500;
      // console.log("cell", cell);
      if (cell.column.dataKey === 0) {
        // paint.Name header red
        cell.cell.styles.cellWidth = 25;
        //
        // cell.styles.textColor = [255, 0, 0];
      } else if (cell.column.dataKey === 1) {
        // cell.cell.styles.fillColor = "blue";
        cell.cell.styles.cellWidth = 25;
      } else if (cell.column.dataKey === 2) {
        // cell.cell.styles.fillColor = "blue";
        cell.cell.styles.cellWidth = 20;
      } else if (cell.column.dataKey === 3) {
        // cell.cell.styles.fillColor = "blue";
        cell.cell.styles.cellWidth = 30;
        // cell.cell.styles.fontSize = 8;
      } else {
        cell.cell.styles.cellWidth = 20;
      }
    },
    head: [
      [
        "Unit Price",
        " Retail Price",
        "Quantity",
        "Partner Net Price",
        "Booking Fee (9.5%)",
        "Partner total Price",
        "Stripe Fees (3%)",
        "Profit",
        "Profit (AED)",
      ],
    ],
    body: [
      [
        (item?.totalAmount?.priceAfterLokaleeDiscount?.recommendedRetailPrice || 0) /
          (item?.order?.totalPax || 1),
        item?.totalAmount?.priceAfterLokaleeDiscount?.recommendedRetailPrice,
        item?.order?.totalPax,
        item?.totalAmount?.priceAfterLokaleeDiscount?.partnerNetPrice,
        item?.totalAmount?.priceAfterLokaleeDiscount?.bookingFee,
        item?.totalAmount?.priceAfterLokaleeDiscount?.partnerTotalPrice,
        item?.stripeFee || 0,
        item?.totalProfit || 0,
        item?.totalNetProfitAED || 0,
      ],
    ],

    tableLineWidth: 0.1,
    tableLineColor: "black",
    tableWidth: "auto",
    startY: doc.lastAutoTable.finalY + 10,
    startX: 20,
    theme: "plain",
    putOnlyUsedFonts: true,
    pageBreak: "auto",

    cellPadding: 5,
    lineWidth: 0.1,
    columnWidth: 100, // 'auto', 'wrap' or a number
  });
  autoTable(doc, {
    head: [["", "Foreign Currency", "Exchange Rate", "AED Currency"]],
    body: [
      [
        "Amount Exclusive of VAT",
        `${(
          item?.totalAmount.priceAfterLokaleeDiscount.recommendedRetailPrice - item.totalVatAmount
        )?.toFixed(2)}`,

        //
        `${item.exchangeRate?.toFixed(4)}`,
        `${(
          (item?.totalAmount.priceAfterLokaleeDiscount.recommendedRetailPrice -
            item.totalVatAmount) *
          item.exchangeRate
        )?.toFixed(2)}`,
      ],
      [
        "VAT Amount",
        `${item.totalVatAmount?.toFixed(2)}`,
        `${item.exchangeRate?.toFixed(4)}`,
        `${(item.totalVatAmount * item.exchangeRate)?.toFixed(2)}`,
      ],
      [
        "Amount Inclusive of VAT ",
        `${item?.totalAmount.priceAfterLokaleeDiscount.recommendedRetailPrice?.toFixed(2)}`,
        `${item.exchangeRate?.toFixed(4)}`,
        `${(
          item?.totalAmount.priceAfterLokaleeDiscount.recommendedRetailPrice?.toFixed(2) *
          item.exchangeRate
        )?.toFixed(2)}`,
      ],
    ],

    // margin: 20,
    tableLineWidth: 0.1,
    tableLineColor: "black",
    tableWidth: 100,
    startY: doc.lastAutoTable.finalY + 17,
    startX: 10,
    styles: { fontSize: 10 },
    avoidPageSplit: true,
    margin: { right: 100, left: 5 },
    theme: "plain",
    // format: "c0",
    putOnlyUsedFonts: true,
    pageBreak: "auto",

    cellPadding: 5,
    lineWidth: 0.1,
    columnWidth: 100, // 'auto', 'wrap' or a number
  });
  autoTable(doc, {
    head: [["", "", ""]],
    body: [
      [
        "Amount Exclusive of VAT",
        "",
        `${item?.currency}: ${(
          (item.totalAmount?.priceAfterLokaleeDiscount?.recommendedRetailPrice ||
            item.totalAmount?.price?.recommendedRetailPrice) - item.totalVatAmount
        )?.toFixed(2)}`,
      ],
      ["Discount", "", `${item?.currency}: ${item?.discount?.toFixed(2) || 0}`],
      [`VAT ${item?.order.vatRate}%`, "", `${item?.currency}: ${item.totalVatAmount?.toFixed(2)}`],
      [
        "TOTAL Invoice",
        "",
        `${
          item?.currency
        }: ${item?.totalAmount.priceAfterLokaleeDiscount.recommendedRetailPrice?.toFixed(2)}`,
      ],
    ],

    // margin: 20,
    tableLineWidth: 0.1,
    tableLineColor: "black",
    tableWidth: 70,
    startY: doc.lastAutoTable.finalY - 55,
    startX: 25,
    styles: { fontSize: 10 },
    avoidPageSplit: true,
    margin: { left: 135 },
    theme: "plain",
    pageBreak: "auto",

    cellPadding: 5,
    lineWidth: 0.1,
    columnWidth: 200, // 'auto', 'wrap' or a number
  });
  doc.save(item?.invoiceNumber);
};
export default PdfInvoices;
